export const infoData = [
  { id: "ready", name: "READY" },
  { id: "unknown", name: "UNKNOWN" },
  { id: "inprogress", name: "IN PROGRESS" },
  { id: "aborting", name: "ABORTING" },
  { id: "aborted", name: "ABORTED" },
  { id: "open", name: "OPEN" },
  { id: "short", name: "SHORT" },
  { id: "remoteshort", name: "REMOTE SHORT" },
  { id: "passed2", name: "PASSED" },
  { id: "straight", name: "STRAIGHT" },
  { id: "crossover", name: "CROSSOVER" },
  { id: "crossover1000bt", name: "CROSSOVER 1000BT" },
  { id: "xover", name: "XOVER" },
  { id: "xover1000bt", name: "XOVER 1000BT" },
  { id: "xoverincomplete", name: "XOVER INCOMPLETE" },
  { id: "miswired", name: "MISWIRED" },
  { id: "splitpair", name: "SPLIT PAIR" },
  { id: "tdrinprogress", name: "TDR IN PROGRESS" },
  { id: "tdrcomplete", name: "TDR COMPLETE" },
  { id: "tdrfailed", name: "TDR FAILED" },
  { id: "abortedpoe", name: "ABORTED PoE" },
  { id: "wiremapinprogress", name: "WIREMAP IN PROGRESS" },
  { id: "splitpairinprogress", name: "SPLIT PAIR IN PROGRESS" },
  { id: "highvoltagealarm", name: "HIGH VOLTAGE ALARM" },
  { id: "unknownvoltagedetected", name: "UNKNOWN VOLTAGE DETECTED" },
  { id: "poevoltagedetected", name: "PoE VOLTAGE DETECTED" },
  { id: "isdnvoltagedetected", name: "ISDN VOLTAGE DETECTED" },
  { id: "pbxvoltagedetected", name: "PBX VOLTAGE DETECTED" }
];
export const infoData2 = [
  { id: "highvoltagealarm", name: "HIGH VOLTAGE ALARM" },
  { id: "unknownvoltagedetected", name: "UNKNOWN VOLTAGE DETECTED" },
  { id: "poevoltagedetected", name: "PoE VOLTAGE DETECTED" },
  { id: "isdnvoltagedetected", name: "ISDN VOLTAGE DETECTED" },
  { id: "pbxvoltagedetected", name: "PBX VOLTAGE DETECTED" }
];
export const shieldType = [
  { id: "0", name: " UTP" },
  { id: "1", name: " STP" },
  { id: "2", name: " UTP/STP" }
];
